import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import {observer} from 'mobx-react';
import {observable, autorun, makeObservable} from 'mobx';
import Portal from './portal';

@observer
export default class VideoModal extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    restoreFocusTo: PropTypes.string,
    onShowModal: PropTypes.func,
    onHideModal: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
  }

  static defaultProps = {
    children: ''
  }

  @observable show = false;

  constructor(props) {
    super(props);
    makeObservable(this);
    autorun(() => {
      // show or hide the modal using bootstrap methods
      if ($(this.modal) && this.show) {
        $(this.modal).modal({backdrop: 'static'});
        $(this.modal).modal('show');

        let event;
        if(typeof window.Event === 'function') {
          //standard event creation (https://developer.mozilla.org/en-US/docs/Web/API/Event/Event)
          event = new Event('showModal', {bubbles: true});
          window.dispatchEvent(event);
        } else {
          //FPSE-3290 manual fallback (https://developer.mozilla.org/en-US/docs/Web/API/Document/createEvent)
          event = document.createEvent('UIEvents');
          event.initEvent('showModal',true/*canBubble*/,true,window,0,0,0,0,0,false,false,false,false,0,null);
        }
      } else {
        $(this.modal).modal('hide');
        $(this.modal).data('bs.modal', null);
      }
    });
  }

  onKeyDown = (e) => {
    //close modal if user hits Escape key
    if (e.keyCode == 27) {
      this.hideModal();
    }
  }

  toggleModal = () => {
    this.show = !this.show;
  }

  showModal = () => {
    this.show = true;
    if (this.props.onShowModal) {
      this.props.onShowModal();
    }
  }

  hideModal = (event) => {
    this.show = false;
    if (this.props.restoreFocusTo) {
      $(this.props.restoreFocusTo).focus();
    }
    if (this.props.onHideModal) {
      this.props.onHideModal(event);
    }
  }

  render() {
    return (
      <div className="video-modal-wrapper" onKeyDown={this.onKeyDown}>
        <Portal>
          <div id={this.props.id}
            ref={i => this.modal = i}
            role="dialog"
            tabIndex={'-1' /* Required to trap focus */}
            className="video-modal modal fade"
            aria-labelledby={this.props.id + '-aria-text'}>
            <div className="row no-gutters modal-dialog" id={this.props.id + '-aria-text'}>
              <div className="col-12 text-center modal-content">
                <div className="hide-modal-button">
                  <button type="button" className="fn-modal-close" onClick={this.hideModal}>
                    <i aria-hidden="true" className="icon-fn-close"></i>
                    <span className="sr-only">Close window</span>
                  </button>
                </div>
                <div className="modal-children col-12 col-md-11 offset-md-0">
                  {this.props.children}
                </div>
              </div>
            </div>
          </div>
        </Portal>
      </div>
    );
  }
}
